export * from './authentication'
export { withFirebase } from './firebase'
import * as Profile from './profiles'

export const APIClient = {
  Profile,
}
